// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "sale".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
import { saleStatusValues, saleTipTypeValues } from '@borradh-workspace/labels';
/** Response atom for the "sale" table (1:1 with a DB row, on the wire). */
export const saleAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    leadId: z.string().nullable(),
    locationId: z.string().nullable(),
    status: z.enum(saleStatusValues),
    subtotalCents: z.number(),
    tipType: z.enum(saleTipTypeValues),
    tipPercent: z.number().nullable(),
    tipCents: z.number(),
    totalCents: z.number(),
    currency: z.string(),
    createdById: z.string(),
    completedAt: z.string().datetime().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=sale.js.map